/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type CalendarEventCode from '@linc-technologies/linced-common/enums/calendar-event-code';
import type SchoolStatus from '@linc-technologies/linced-common/enums/school-status';

// Proto: dates.Date.
export default class Date extends Model {
  declare [Type]: 'date';

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @attr('string')
  declare date: string | undefined;

  @attr('number', { defaultValue: 0 })
  declare status: EnumValue<typeof SchoolStatus> | 0;

  @attr('number', { defaultValue: 0 })
  declare week: number;

  // term is 0 for a date that is not in a term (a holiday).
  @attr('number', { defaultValue: 0 })
  declare term: number;

  @attr('string', { defaultValue: '' })
  declare holidayDescription: string;

  @attr('array')
  declare holidayYears: unknown;

  @attr('boolean', { defaultValue: false })
  declare dateExplained: boolean;

  @attr('number', { defaultValue: 0 })
  declare calendarEventCode: EnumValue<typeof CalendarEventCode> | 0;

  @computed('status')
  get statusClass() {
    switch (this.status) {
      case 1:
        return 'school-state-open';
      case 2:
        return 'school-state-closed';
      case 3:
        return 'school-state-morning';
      case 4:
        return 'school-state-afternoon';
    }
    return '';
  }

  @computed('term')
  get termClass() {
    const term = this.term;
    if (term) {
      return `school-dates-term-${term}`;
    }
    return '';
  }
}
